function locale(territory) {
    switch (territory) {
        case 'usa':
            return 'en_US'

        case 'aus':
            return 'en_AU'

        case 'gbr':
        default:
            return 'en_UK'
    }
}

export { locale }
